export const blockIconsHomeDoorOpenNew = (
	<span className='material-symbols-outlined'>door_open</span>
);
